import { render, staticRenderFns } from "./DetailVideoCourse.vue?vue&type=template&id=180b2910"
import script from "../../services/teacher/detail-video-class.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/detail-video-class.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports